/**
 * This file is part of ONP.
 *
 * Copyright (c) 2014 Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone', 'assets/js/modules/designFacePreview/guideLines/arrowLegendPresenter'], function(backbone, ArrowLegendPresenter) {
    return backbone.Model.extend({
        defaults: {
            text: null,
            color: null,
            widthOffset: 0,
            topOffset: 0,
            presenter: ArrowLegendPresenter
        }
    });
});
